import React from "react";
import { useAnimation as UseAnimation, motion } from "framer-motion";
import Header from "@/components/Header";
import Footer from "@/components/Footer";

import Image from "next/image";
import Link from "next/link";

import Step from "@/public/static/images/step_arrow.png";

import DM01 from "@/public/static/images/dmkt_c_01.png";
import DM02 from "@/public/static/images/dmkt_c_02.png";
import DM03 from "@/public/static/images/dmkt_c_03.png";
import DM04 from "@/public/static/images/dmkt_c_04.png";
import DM05 from "@/public/static/images/dmkt_c_05.png";
import DM06 from "@/public/static/images/dmkt_c_06.png";

import PJ01 from "@/public/static/images/dkmt-pj-01.jpg";
import PJ02 from "@/public/static/images/dkmt-pj-02.jpg";
import PJ03 from "@/public/static/images/dkmt-pj-03.jpg";

function digital_marketing() {
  const img: any = "/static/images/s-dmkt.png";

  const imgAnimation = UseAnimation();

  const handleMouseMove = (e: any) => {
    const { clientX, clientY } = e;
    const moveX = clientX - window.innerWidth / 2;
    const moveY = clientY - window.innerHeight / 2;
    const offsetFactor = 15;
    imgAnimation.start({
      x: moveX / offsetFactor,
      y: moveY / offsetFactor,
    });
  };

  return (
    <div className="wrapper">
      <Header />
      <section className="key_visual">
        <motion.img
          // animate={imgAnimation}
          // onMouseMove={(e) => handleMouseMove(e)}
          src={img}
          alt="Event Activation"
          loading="lazy"
        />
        <div className="img-bg" />
      </section>

      <section className="sv_content dmkt-content">
        <div className="container">
          <div className="row">
            <div className="col-12 heading-top_content">
              <div className="d-flex justify-content-center">
                <h2>Digital Marketing / Design / Movie</h2>
              </div>
            </div>
            <div className="col-12 sv_content-inner">
              <p className="mb-4">
                The Internet world has possible ways to introduce clients'
                "services" and "products" to a massive audience of users and
                highlight their advantages. For example, there is a technique to
                display your website in Google search results and there is also
                a method to present advertisements on websites and mobile
                applications in order to attracts interest from people globally
                since many people have smartphones.
              </p>
              <p className="mb-4">
                Social networks and digital transformation (DX), which are
                "services" and "products", have been more widespread since 2020,
                and SNS (Social Network Service) is now more prevalent.
                Spreading a company's information on social media and getting
                plenty of viewers and "fans" is essential not only for achieving
                quick results but also for sustained corporate activities.
              </p>
              <p className="mb-4">
                ITP Asia has concentrated on digital content in Southeast Asia
                since 2010 and invested in SVEN Group, a significant local
                digital marketing company in the Philippines. Now, we are also
                working to enhance the quality and quantity of digital marketing
                services in Southeast Asia.
              </p>
              <p className="mb-4">
                We combine “ITP Asia's expression ability”, “ITP Asia's
                network”, and “Interesting & powerful platforms in the world”
                like SNS etc. together in order to support connecting customers
                with their fans.
              </p>
              <ul>
                <li>
                  SNS (Facebook, YouTube, Instagram, Twitter, TikTok, LinkedIn)
                </li>
                <li>Movie & Drone</li>
                <li>Design (2D, 3D)</li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* <section className="sv_content black-content">
        <div className="container">
          <div className="row">
            <div className="col-12 text-center ev-heading-spr_bl mb-5">
              <h1 className="fw-bolder t-blue">
                Digital Marketing becomes a MUST!
              </h1>
              <h2 className="t-white">
                Let your business reach more audience anywhere online Leverage
                the power of social media to grow your brand presence, and
                engage with your target audience anytime.
              </h2>
              <h2 className="t-white">
                With digital marketing, it helps you business get…
              </h2>
            </div>
          </div>
          <div className="row">
            <div className="col-12 col-md-6 col-lg-4 dmkt-content mb-4">
              <div className="card h-100 dmkt-content_detail text-center">
                <div className="card-body">
                  <h1>Increase Reach</h1>
                  <p className="text-spr-strong">
                    There are over
                    <span>
                      <i>4.6 Billion</i>
                    </span>
                    active internet users
                  </p>
                  <p className="text-spr-strong">
                    And over
                    <span>
                      <i>4.2 Billion</i>
                    </span>
                    active social media users
                  </p>
                  <p className="text-spr-strong">worldwide</p>
                </div>
              </div>
            </div>

            <div className="col-12 col-md-6 col-lg-4 dmkt-content mb-4">
              <div className="card h-100 dmkt-content_detail text-center">
                <div className="card-body">
                  <h1>Higher Engagement</h1>
                  <p className="text-spr-strong">
                    <span>Up to</span>
                    <span>
                      <i>X</i>3
                    </span>
                    <span className="mb-2">Higher Leads</span>
                    generated by
                    <br />
                    <strong>Content Marketing</strong>
                    <br />
                    than traditional
                    <br />
                    Outbound Marketing
                  </p>
                </div>
              </div>
            </div>

            <div className="col-12 col-md-6 col-lg-4 dmkt-content mb-4">
              <div className="card h-100 dmkt-content_detail text-center">
                <div className="card-body">
                  <h1>Better Targeting</h1>
                  <p className="text-spr-strong">
                    <span>
                      <i>10%</i>increase
                    </span>
                    of customer retention rate
                    <br />
                    by using{" "}
                    <strong>
                      data-driven
                      <br />
                      personalization marketing
                    </strong>
                    <br />
                    based on
                  </p>
                  <ul>
                    <li>Demographics</li>
                    <li>Interests</li>
                    <li>Online Behaviors</li>
                    <li>and many more</li>
                  </ul>
                </div>
              </div>
            </div>

            <div className="col-12 col-md-6 col-lg-4 dmkt-content mb-4">
              <div className="card h-100 dmkt-content_detail text-center">
                <div className="card-body">
                  <h1>Improve Customer Experience</h1>
                  <p className="text-spr-strong">
                    <i>84%</i> of customers
                    <br />
                    value the <strong>experience</strong>
                    <br />
                    provided by a company <br />
                    <strong>
                      as important as products <br />
                      and services.
                    </strong>
                  </p>
                  <p className="text-spr-strong">
                    The more <strong>personalized</strong> content,
                    <br />
                    the <strong>better customer experience,</strong> resulting
                    in customer loyalty.
                  </p>
                </div>
              </div>
            </div>

            <div className="col-12 col-md-6 col-lg-4 dmkt-content mb-4">
              <div className="card h-100 dmkt-content_detail text-center">
                <div className="card-body">
                  <h1>Cost-Effective</h1>
                  <p className="text-spr-strong">
                    Up to
                    <span>
                      <i>40%</i>
                    </span>{" "}
                    of marketing costs
                    <br />
                    can be saved by deploying
                    <br />
                    <strong>digital marketing tools</strong> and
                    <br />
                    <strong>data</strong> for effective targeting,
                    <br />
                    customization,
                    <br />
                    and optimization
                    <br />
                    to achieve better result
                  </p>
                </div>
              </div>
            </div>

            <div className="col-12 col-md-6 col-lg-4 dmkt-content mb-4">
              <div className="card h-100 dmkt-content_detail text-center">
                <div className="card-body">
                  <h1>Real-time Measurement and Optimization</h1>
                  <p className="text-spr-strong">
                    Digital Marketing tools allow
                    <br />
                    <strong>
                      Real-time measurement
                      <br />
                      Data-driven decision making
                      <br />
                      Real-time optimization
                    </strong>
                  </p>
                  <p className="text-spr-strong">
                    For constantly <br />
                    <strong>improving</strong> the effectiveness <br />
                    of digital marketing campaign, <br />
                    <strong>interacting</strong> with the target, <br />
                    and <strong>driving growth</strong> to meet your <br />
                    digital marketing campaign.
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="row mt-5">
            <div className="col-12 text-center ev-heading-spr_bl">
              <div className="row justify-content-md-center">
                <div className="col-12 col-lg-6">
                  <h2 className="t-white mb-4">
                    Let digital marketing tools, data, together with our
                    marketing strategy planned by specialists bring you the best
                    performance and desirable outcomes to any of your business
                    campaigns.
                  </h2>
                </div>
              </div>
              <h1 className="fw-bolder t-blue mb-0">
                We support you in every step of your business goal.
              </h1>
            </div>
          </div>
        </div>
      </section> */}

      <section className="sv_content gray-content">
        <div className="container">
          <div className="row justify-content-md-end text-end">
            <div className="col-12 step-dmkt">
              <div className="img-setp">
                <Image loading="lazy" src={Step} alt="" className="img-fluid mx-auto" />
              </div>
              <div className="step-dmkt_inner hidden">
                <div className="step-dmkt_inner-06">
                  <h2 className="num-06 t-white">
                    <i>6</i>
                    <span className="step_num">
                      Measure and analyze the result
                    </span>
                  </h2>
                </div>
              </div>
              <div className="step-dmkt_inner hidden">
                <div className="step-dmkt_inner-05">
                  <h2 className="num-05 t-white">
                    <i>5</i>
                    <span className="step_num">
                      Leverage digital marketing tools
                    </span>
                  </h2>
                </div>
              </div>
              <div className="step-dmkt_inner hidden">
                <div className="step-dmkt_inner-04">
                  <h2 className="num-04 t-white">
                    <i>4</i>
                    <span className="step_num">
                      Optimize your website:{" "}
                      <strong className="t-black">
                        searchable, user friendly, rich content
                      </strong>
                    </span>
                  </h2>
                </div>
              </div>
              <div className="step-dmkt_inner hidden">
                <div className="step-dmkt_inner-03">
                  <h2 className="num-03 t-white">
                    <i>3</i>
                    <span className="step_num">
                      Create valuable,
                      <strong className="t-black">informative,</strong> and{" "}
                      <strong className="t-black">engaging</strong>
                      content constantly
                    </span>
                  </h2>
                </div>
              </div>
              <div className="step-dmkt_inner hidden">
                <div className="step-dmkt_inner-02">
                  <h2 className="num-02 t-white">
                    <i>2</i>
                    <span className="step_num">
                      Develop a digital marketing{" "}
                      <strong className="t-black">strategy</strong> and{" "}
                      <strong className="t-black">plan</strong>
                      and determine which{" "}
                      <strong className="t-black">tools</strong> to use
                    </span>
                  </h2>
                </div>
              </div>
              <div className="step-dmkt_inner hidden">
                <div className="step-dmkt_inner-01">
                  <h2 className="num-01 t-white">
                    <i>1</i>
                    <span className="step_num">
                      Define your{" "}
                      <strong className="t-black">goals, objectives,</strong>{" "}
                      and <strong className="t-black">target audience</strong>{" "}
                      of your campaign
                    </span>
                  </h2>
                </div>
              </div>
            </div>
          </div>

          <div className="row mt-5">
            <div className="col-12 text-center ev-heading-spr_bv mb-5">
              <h1 className="fw-bolder t-blue mb-0">Our service includes…</h1>
              <h2>(But not limited to)</h2>
            </div>
          </div>
          <div className="row">
            <div className="col-12 col-md-6 col-lg-4 dmkt-sv mb-4">
              <div className="card h-100">
                <div className="card-body text-center">
                  <h2 className="t-white">Marketing Proposal</h2>
                  <div className="dmkt-img">
                    <Image loading="lazy"
                      src={DM01}
                      alt="Marketing Proposal"
                      className="img-fluid mx-auto"
                    />
                  </div>
                  <ul className="t-white">
                    <li>Set the goal and objective</li>
                    <li>Design proposal for your needs</li>
                    <li>
                      Consider marketing approach
                      <br />
                      and tools that fit your campaign
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            <div className="col-12 col-md-6 col-lg-4 dmkt-sv mb-4">
              <div className="card h-100">
                <div className="card-body text-center">
                  <h2 className="t-white">Project Planning</h2>
                  <div className="dmkt-img">
                    <Image loading="lazy"
                      src={DM02}
                      alt="Project Planning"
                      className="img-fluid mx-auto"
                    />
                  </div>
                  <ul className="t-white">
                    <li>
                      Plan each and every step for
                      <br />
                      the campaign’s best outcome
                    </li>
                    <li>Plan content schedule</li>
                  </ul>
                </div>
              </div>
            </div>

            <div className="col-12 col-md-6 col-lg-4 dmkt-sv mb-4">
              <div className="card h-100">
                <div className="card-body text-center">
                  <h2 className="t-white">Communication Design</h2>
                  <div className="dmkt-img">
                    <Image loading="lazy"
                      src={DM03}
                      alt="Communication Design"
                      className="img-fluid mx-auto"
                    />
                  </div>
                  <ul className="t-white">
                    <li>Set the communication strategy</li>
                    <li>
                      Design communication method to
                      <br />
                      meet the target audience
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            <div className="col-12 col-md-6 col-lg-4 dmkt-sv mb-4">
              <div className="card h-100">
                <div className="card-body text-center">
                  <h2 className="t-white">Content Creation</h2>
                  <div className="dmkt-img">
                    <Image loading="lazy"
                      src={DM04}
                      alt="Content Creation"
                      className="img-fluid mx-auto"
                    />
                  </div>
                  <ul className="t-white">
                    <li>Conceptualize the project</li>
                    <li>Write the content</li>
                    <li>Photo and video shooting</li>
                    <li>Photo and video editing</li>
                    <li>Visual Design</li>
                  </ul>
                </div>
              </div>
            </div>

            <div className="col-12 col-md-6 col-lg-4 dmkt-sv mb-4">
              <div className="card h-100">
                <div className="card-body text-center">
                  <h2 className="t-white">Monitor</h2>
                  <div className="dmkt-img">
                    <Image loading="lazy"
                      src={DM05}
                      alt="Monitor"
                      className="img-fluid mx-auto"
                    />
                  </div>
                  <ul className="t-white">
                    <li>Monitor SNS platform</li>
                    <li>Organize backend system</li>
                    <li>Post & Ads settings</li>
                    <li>Content Maintenance</li>
                  </ul>
                </div>
              </div>
            </div>

            <div className="col-12 col-md-6 col-lg-4 dmkt-sv mb-4">
              <div className="card h-100">
                <div className="card-body text-center">
                  <h2 className="t-white">Performance Analysis & Report</h2>
                  <div className="dmkt-img">
                    <Image loading="lazy"
                      src={DM06}
                      alt="Performance Analysis & Report"
                      className="img-fluid mx-auto"
                    />
                  </div>
                  <ul className="t-white">
                    <li>Statistics Analysis</li>
                    <li>Performance Summary</li>
                    <li>Improvement Suggestion</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="sv_content black-content">
        <div className="container">
          <div className="row">
            <div className="col-12 text-center ev-heading-spr_bv">
              <h3 className="t-white">
                Here are some of our work that may inspire you!
              </h3>
            </div>
          </div>

          <div className="row">
            <div className="col-12 file-card my-4 mb-5">
              <div className="card h-100">
                <div className="file_card-inner">
                  <div className="row">
                    <div className="col-12 col-md-6 dkmt_content-file_card position-relative">
                      <h1 className="t-white">
                        Digital Content
                        <br />
                        For various purpose
                      </h1>
                      <h2 className="t-white">
                        We tailored every single content to meet target audience
                        in different platform
                      </h2>
                      <div className="position-absolute bottom-0 start-0">
                        <h1 className="t-white mb-0 lh-1">
                          Digital Content Creation
                        </h1>
                      </div>
                    </div>
                    <div className="col-12 col-md-6 dkmt_img-file_card pt-4 mt-2">
                      <Image loading="lazy"
                        src={PJ01}
                        alt="Digital Content Creation"
                        className="img-fluid mx-auto"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-12 text-center ev-heading-spr_bv mt-5">
              <h3 className="t-white">
                Here are some of our work that may inspire you!
              </h3>
            </div>
          </div>

          <div className="row">
            <div className="col-12 file-card mb-4 my-4">
              <div className="card h-100">
                <div className="file_card-inner">
                  <div className="row">
                    <div className="col-12 col-md-6 dkmt_content-file_card position-relative">
                      <h1 className="t-white">
                        Digital Content
                        <br />
                        For various purpose
                      </h1>
                      <h2 className="t-white">
                        We tailored every single content to meet target audience
                        in different platform
                      </h2>
                      <div className="position-absolute bottom-0 start-0">
                        <h1 className="t-white mb-0 lh-1">
                          Digital Content Creation
                        </h1>
                      </div>
                    </div>
                    <div className="col-12 col-md-6 dkmt_img-file_card pt-4 mt-2">
                      <Image loading="lazy"
                        src={PJ02}
                        alt="Digital Content Creation"
                        className="img-fluid mx-auto"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-12 text-center ev-heading-spr_bv mt-5">
              <h3 className="t-white">
                Here are some of our work that may inspire you!
              </h3>
            </div>
          </div>

          <div className="row">
            <div className="col-12 file-card mb-4 my-4">
              <div className="card h-100">
                <div className="file_card-inner">
                  <div className="row">
                    <div className="col-12 col-md-6 dkmt_content-file_card position-relative">
                      <h1 className="t-white">
                        Digital Content
                        <br />
                        For various purpose
                      </h1>
                      <h2 className="t-white">
                        We tailored every single content to meet target audience
                        in different platform
                      </h2>
                      <div className="position-absolute bottom-0 start-0">
                        <h1 className="t-white mb-0 lh-1">
                          Digital Content Creation
                        </h1>
                      </div>
                    </div>
                    <div className="col-12 col-md-6 dkmt_img-file_card pt-4 mt-2">
                      <Image loading="lazy"
                        src={PJ03}
                        alt="Digital Content Creation"
                        className="img-fluid mx-auto"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="sv_content gray-content">
        <div className="container">
          <div className="row">
            <div className="col-12 text-center ev-heading-spr_bl">
              <h1 className="fw-bolder">Spark some ideas already?</h1>
              <h2 className="lh-1">
                Do not let the chance to be seen worldwide pass
                <br />
                Contact us today and let’s execute your ideas together!
              </h2>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}

export default digital_marketing;
